export default "__VITE_ASSET__CAbr3irs__"